import { createReducer, on } from '@ngrx/store';
import { Delayed } from '../lemans-app.model';
import { initialUserAccessState, UserAccessState, UserRoleHierarchy } from './domain';
import { UserAccessActions } from './store';

export const userAccessReducer = createReducer(
  initialUserAccessState,
  on(
    UserAccessActions.setUserRoleHierarchy,
    (state: UserAccessState, { userRoleHierarchy }): UserAccessState => ({
      ...state,
      userRoleHierarchy: new Delayed<UserRoleHierarchy>(userRoleHierarchy),
    }),
  ),
  on(UserAccessActions.clearUserRoleHierarchy, (): UserAccessState => initialUserAccessState),
);
